import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";

import Header from "../components/header";
import Footer from "../components/footer";

import GatsbyConfig from "../../gatsby-config";

import "./index.css";

const TemplateWrapper = ({ children, data }) => (
  <div>
    <Helmet
      title="Code Sculpture (from James Porter)"
      meta={[
        { name: "description", content: "Create 3D art from simple rules" }
      ]}
    />
    <Header />

    <div className="content">{children()}</div>

    <Footer />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js